module.exports = __webpack_public_path__ + "img/lil.19a60170.jpeg";